export const PLATFORM_SELECTOR_NAME = "PLATFORM_SELECTOR";
